export default __webpack_public_path__ + "media/images/holiday-bg-a6f30442b71b7bfd5ab80b963e81e50f.jpg";